<mat-sidenav-container
  (dragover)="onDragOver($event)"
  class="sidenav-container"
  [attr.data-testid]="testIds.sidenavContainer">
  <mat-sidenav
    [class.opened]="!isSidebarHidden()"
    [class.closed]="isSidebarHidden()"
    class="sidenav"
    [attr.data-testid]="testIds.sidenavSidenav"
    disableClose
    mode="side"
    opened="opened">
    @if (!isSidebarHidden()) {
      <mat-icon svgIcon="tim-logo" [attr.data-testid]="testIds.sidebarHeaderIcon"></mat-icon>
    } @else {
      <mat-icon svgIcon="collapsed-tim" [attr.data-testid]="testIds.sidebarHeaderIcon"></mat-icon>
    }
    <app-searchbar
      (searchTermChange)="onSearch($event)"
      [collapsed]="isSidebarHidden()"
      [dataTestId]="testIds.searchInput"
      [class.collapsed]="isSidebarHidden()"
      class="searchbar"
      placeholder="Schnellsuche"></app-searchbar>
    <hr />
    <mat-accordion [attr.data-testid]="testIds.sidebarAccordion">
      @let invitedRooms = (invitedRooms$ | async)!;
      @if (invitedRooms.length > 0) {
        <app-dropdown
          label="Einladungen"
          [dataTestId]="testIds.dropdownInvite"
          [collapsed]="isSidebarHidden()"
          [dropdownDataTestId]="testIds.inviteRoomsDropdown">
          <app-counter-badge
            class="extra-component"
            [class.collapsedCounter]="isSidebarHidden()"
            [dataTestId]="testIds.inviteCounterBadge"
            [count]="invitedRooms.length" />
          @for (room of invitedRooms; track room) {
            <ng-container
              *ngTemplateOutlet="
                dropdownTemplate;
                context: {
                  room: room,
                  index: $index
                }
              "></ng-container>
          }
        </app-dropdown>
        <hr />
      }
      <app-dropdown
        #privateDropdown
        [collapsed]="isSidebarHidden()"
        [dataTestId]="testIds.dropdownChats"
        label="Chats"
        [dropdownDataTestId]="testIds.privateRoomsDropdown">
        <app-create-room-dialog
          (navigatedRoom)="sessionService.setSessionRoomId($event)"
          [collapsed]="isSidebarHidden()"
          [privateDropdownComponent]="privateDropdown"
          [publicDropdownComponent]="publicDropdown"
          class="extra-component" />
        @for (room of filteredPrivateRooms$ | async; track $index) {
          <ng-container *ngTemplateOutlet="dropdownTemplate; context: { room: room, index: $index }"></ng-container>
        } @empty {
          <p class="empty-info">Aktuell gibt es keinen aktiven Chat.</p>
        }
      </app-dropdown>
      <hr />
      <app-dropdown
        #publicDropdown
        [collapsed]="isSidebarHidden()"
        [dataTestId]="testIds.dropdownChats"
        label="Öffentliche Chats"
        [dropdownDataTestId]="testIds.publicRoomsDropdown">
        <app-search-public-room-dialog
          (navigatedRoom)="sessionService.setSessionRoomId($event)"
          [collapsed]="isSidebarHidden()"
          [privateDropdownComponent]="privateDropdown"
          [publicDropdownComponent]="publicDropdown"
          class="extra-component" />
        @for (room of filteredPublicRooms$ | async; track $index) {
          <ng-container *ngTemplateOutlet="dropdownTemplate; context: { room: room, index: $index }"></ng-container>
        }
      </app-dropdown>
    </mat-accordion>
    <div [class.collapsed]="isSidebarHidden()" class="sidenav_bottom">
      <hr [class.collapsed]="isSidebarHidden()" />
      <div [class.collapsed]="isSidebarHidden()" class="user-info">
        <app-user-icon
          [matTooltip]="userDisplayName"
          [class.collapsed]="isSidebarHidden()"
          [userId]="userId"
          [presenceStatus]="presenceService.getPresence(userId)"
          class="user-icon"></app-user-icon>
        @if (!isSidebarHidden()) {
          <div class="user-text">
            <p class="user-display-name">
              <span [attr.data-testid]="testIds.userDisplayName">{{ userDisplayname$ | async }}</span>
            </p>
            <p class="user-ti-m-adresse" #userIdElement>
              {{ userId }}
            </p>
          </div>
        }
      </div>

      <div [class.collapsed]="isSidebarHidden()" class="bottom-buttons" [attr.data-testid]="testIds.bottomButtons">
        <app-button
          (clicked)="logout()"
          [collapsed]="isSidebarHidden()"
          [dataTestId]="testIds.buttonLogout"
          [isPrimary]="true"
          text="Log out">
          <mat-icon svgIcon="logout-icon"></mat-icon>
        </app-button>
        <app-button
          (clicked)="openSettings()"
          [dataTestId]="testIds.buttonSettingsmenu"
          class="sb-settings"
          [class.collapsed]="isSidebarHidden()"
          tooltip="Einstellungen">
          <mat-icon svgIcon="settings-icon"></mat-icon>
        </app-button>
      </div>
    </div>

    <div class="sidebar-footer" [class.collapsed]="isSidebarHidden()" [attr.data-testid]="testIds.sidebarFooter">
      <p class="version-info">
        @if (!isSidebarHidden()) {
          <span
            tabindex="0"
            class="footer-text"
            [style.width]="'auto'"
            [style.display]="'inline-block'"
            (click)="openVersionInfo()"
            (keydown.enter)="openVersionInfo()"
            onKeyUp="openVersionInfo()"
            [attr.data-testid]="testIds.sidebarVersionText">
            {{ environment.timClientVersion }}
          </span>
        }
        <button
          (click)="toggleSidebar()"
          [class.collapsed]="isSidebarHidden()"
          class="toggle-sidebar-button"
          [style.float]="isSidebarHidden() ? 'left' : 'right'"
          [attr.data-testid]="testIds.buttonToggleSideNav">
          @if (isSidebarHidden()) {
            <mat-icon svgIcon="double-arrow-left" [class.rotated]="isSidebarHidden()"></mat-icon>
          }
          @if (!isSidebarHidden()) {
            <mat-icon svgIcon="double-arrow-left"></mat-icon>
          }
        </button>
      </p>
    </div>
  </mat-sidenav>
  <mat-sidenav-content
    [style.margin-left]="isSidebarHidden() ? '7.8rem' : '24.6rem'"
    class="main-content"
    [attr.data-testid]="testIds.mainContent">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>

<ng-template #dropdownTemplate let-room="room">
  <app-user-card
    [attr.data-testid]="room.roomId"
    (click)="navigateToRoom($event, room)"
    (keydown.enter)="navigateToRoom($event, room); $event.stopPropagation(); $event.preventDefault()"
    onKeyUp="navigateToRoom($event, room)"
    [currentUserId]="matrix.getUserId()"
    [isAbandoned]="hasRoomBeenAbandoned(room.roomId)"
    [isActive]="(chatStoreService.getCurrentRoomId$() | async) === room.roomId"
    [cardTitle]="room.name"
    [collapsed]="isSidebarHidden()"
    [roomId]="room.roomId"
    tabindex="0"
    cardContentDataTestid="cardcontent_public_chats"
    cardDataTestid="card_public_chats"
    cardHeaderDataTestid="cardheader_public_chats"
    cardTitleDataTestid="cardtitle_public_chats" />
</ng-template>

<ng-template #deletionDialog let-data>
  <mat-dialog-content class="delete-content">
    <mat-icon svgIcon="circle-info" class="info-icon"></mat-icon>
    <h2 class="delete-title" mat-dialog-title>INAKTIVEN CHAT LÖSCHEN?</h2>
    <p class="delete-message">
      Dieser Chat ist länger als {{ settingsOriginator.state.deletionPeriodConfigurations.timeUntilDeletion }}
      Monate inaktiv. Wenn Sie ihn löschen, wird er archiviert und verlassen. Wollen Sie den Chat löschen?
    </p>
    <div class="user-card-delete">
      @for (room of data; track room.roomId) {
        <app-user-card
          (click)="navigateToRoom($event, room)"
          [roomId]="room.roomId"
          [cardTitle]="room.name"
          [isDeletionDialog]="true"
          (checkedWithId)="collectRoomIdsForDeletion($event)"
          [isActive]="roomsToDeleteIds.includes(room.roomId)"
          [currentUserId]="matrix.getUserId()"
          [cardContentDataTestid]="testIds.cardcontentChatsToDelete"
          [cardDataTestid]="testIds.cardChatsToDelete"
          [cardHeaderDataTestid]="testIds.cardheaderChatsToDelete"
          [cardTitleDataTestid]="testIds.cardtitleChatsToDelete"
          [collapsed]="false" />
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="btn-container">
      <app-button
        [isDisabled]="roomsToDeleteIds.length === 0"
        (clicked)="leaveAndForgetRooms()"
        [attr.data-testid]="testIds.leaveAndForgetRoomsButton"
        text="Ja"></app-button>
      <app-button
        [attr.data-testid]="testIds.nextLoginButton"
        (clicked)="matDialog.closeAll()"
        text="beim nächsten Login"></app-button>
      <app-button
        (clicked)="navigateToSettings()"
        [isPrimary]="true"
        [attr.data-testid]="testIds.deleteSettingsChangeButton"
        text="Einstellungen ändern"></app-button>
    </div>
  </mat-dialog-actions>
</ng-template>
<ng-template #inviteDialog let-data>
  <mat-dialog-content class="invite-container">
    <mat-icon svgIcon="circle-info" class="info-icon"></mat-icon>

    <h2 class="invite-title">EINLADUNG ZUM CHAT</h2>

    <div class="invite-card">
      <div class="invite-top">
        <app-user-icon
          class="avatar"
          [userId]="data.senderId"
          [presenceStatus]="presenceService.getPresence(data.senderId)">
        </app-user-icon>

        <div class="invite-text">
          <div>
            Eingeladen von:
            <strong>{{ data.senderName }}</strong>
          </div>

          <div class="mxid">MXID: {{ data.senderId }}</div>

          <div class="chat-section">
            <div>Im Chat:</div>
            <div class="chat-name">{{ data.roomName }}</div>
          </div>
        </div>
      </div>
      <hr />

      <div class="invite-question">Möchtest du diese Einladung annehmen und dem Chat beitreten?</div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="invite-actions">
    <app-button text="Einladung zurücklegen" (clicked)="declineInvite()"> </app-button>

    <app-button
      text="Einladung annehmen"
      [isPrimary]="true"
      [attr.data-testid]="testIds.buttonConfirmJoin"
      (clicked)="acceptInvite(data.roomId, { displayname: data.senderName, mxid: data.senderId })">
    </app-button>
  </mat-dialog-actions>
</ng-template>
